import { render, staticRenderFns } from "./AlliancesInformation.vue?vue&type=template&id=2351e021"
import script from "./AlliancesInformation.vue?vue&type=script&lang=js"
export * from "./AlliancesInformation.vue?vue&type=script&lang=js"
import style0 from "./AlliancesInformation.vue?vue&type=style&index=0&id=2351e021&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports